<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-card>
                <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-text-field v-model="currentItem.product_code" label="Mã sản phẩm"
                            class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-text-field v-model="currentItem.staff_name" label="Người tạo"
                            class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-textarea v-model="currentItem.note" label="Ghi chú"
                            class="input-group--focused"></v-textarea>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs2>
                        <v-btn class="ma-2" color="indigo" dark @click="(dialogUpload = true)"><v-icon
                                dark>upload</v-icon></v-btn>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-layout row wrap class="images"  v-viewer="options">
                            <!-- Existing saved images -->
                            <div class="attach-image mr-4" v-for="(f, index) in currentItem.images" v-bind:key="'saved-' + f.id">
                                <img style="width: 64px; height: 64px;" :src="f.path">
                                <v-btn color="red" icon x-small @click="fileRemove(index)"><v-icon>fas fa-times-circle</v-icon></v-btn>
                            </div>
                            <!-- Preview images (not yet saved) -->
                            <div class="attach-image mr-4 preview-image" v-for="(preview, index) in previewImages" v-bind:key="'preview-' + index">
                                <img style="width: 64px; height: 64px;" :src="preview.url" :alt="preview.name">
                                <v-btn color="red" icon x-small @click="removePreviewImage(index)"><v-icon>fas fa-times-circle</v-icon></v-btn>
                                <div class="preview-overlay">
                                    <v-icon small color="orange">visibility</v-icon>
                                </div>
                            </div>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
        <upload-file :dialogUpload="dialogUpload" :file_types="'.png, .jpg, .jpeg'" title="Tải file hình ảnh" @closePopup="dialogUpload = false" @importFile="uploadFile"></upload-file>
    </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import upload_file from "@/components/popups/upload_file";
export default {
    components: {
        "upload-file": upload_file
    },
    data() {
        return {
            options: {
            inline: false,
            button: true,
            navbar: true,
            title: 2,  // show if screen > 768px
            toolbar: {
            zoomIn: 1,
            zoomOut: 1,
            oneToOne: 1,
            reset: 1,
            prev: 1,
            play: {
                show: 1,
                size: 'large',
            },
            next: 1,
            rotateLeft: 1,
            rotateRight: 1,
            flipHorizontal: 1,
            flipVertical: 1,
            },
            tooltip: true,
            movable: true,
            zoomable: true,
            rotatable: true,
            scalable: true,
            transition: true,
            fullscreen: true,
            keyboard: true,
        },
            dialogUpload: false,
            formData: null,
            previewImages: [] // Store preview images before save
        }
    },
    computed: {
        ...mapState({
            loading: state => state.products.loading,
            currentItem: state => state.products.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        is_admin() {
            return this.$store.state.authentication.user.is_admin;
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("products/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("products/setDetail", {
                    data: {
                        id: 0
                    }
                })
            }
        },
        saveData() {
            if(!this.is_admin) {
                sendErrorNotice('Bạn không có quyền chỉnh sửa & tạo mới sản phẩm');
                return;
            }
            this.$store.dispatch("products/setDetail", {
                data: {
                    ...this.currentItem,
                },
                id: this.currentItem.id
            }).then(p => {
                if (this.formData) {
                    this.formData.append('product_id', this.currentItem.id || p.data.id);
                    this.$store.dispatch("commons/upload_media_file", this.formData).then(() => {
                        // Clear preview images after successful upload
                        this.previewImages = [];
                        this.refreshData(); // Refresh to show newly uploaded images
                    });
                    this.formData = null;
                }
                if(!this.currentItem.id) {
                    this.$router.push({
                        name: "ProductDetail",
                        params: {
                            Pid: p.data.id,
                            title: `Chi tiết sản phẩm (#${p.data.id})`
                        }
                    });
                }
                
            });
        },
        uploadFile(filelist) {
            this.formData = new FormData();
            this.previewImages = []; // Clear existing previews
            
            filelist.forEach((file) => {
                this.formData.append(`images[]`, file); // Tên tham số là "images"
                
                // Create preview for each file
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImages.push({
                        url: e.target.result,
                        name: file.name,
                        file: file
                    });
                };
                reader.readAsDataURL(file);
            });
            this.dialogUpload = false;
        },
        fileRemove(index) {
            this.currentItem.images.splice(index, 1);
        },
        removePreviewImage(index) {
            // Remove from preview array
            this.previewImages.splice(index, 1);
            
            // Rebuild FormData without the removed file
            if (this.previewImages.length > 0) {
                this.formData = new FormData();
                this.previewImages.forEach((preview) => {
                    this.formData.append(`images[]`, preview.file);
                });
            } else {
                this.formData = null;
            }
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
    },
};
</script>
<style type="text/css" scoped>
.attach-image {
    position: relative;
    width: 64px;
}

.attach-image button {
    position: absolute;
    right: 0;
    top: 0;
}

.attach-image .v-image {
    cursor: pointer;
}

.preview-image {
    border: 2px dashed #ff9800;
    border-radius: 4px;
    background-color: rgba(255, 152, 0, 0.1);
}

.preview-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: rgba(255, 152, 0, 0.8);
    color: white;
    padding: 2px 4px;
    border-radius: 0 4px 0 0;
    font-size: 10px;
}
</style>
